export const tables = {
  compass: {
    //window.USR_SM_CMP_SIMULATORE_PROD_TABELLE.STANDARD
    tassicfg_key: 'USR_SM_CMP_SIMULATORE_PROD_TABELLE',
    codes: {
    "9XX": 870,
    "9XZ": 871,
    },
    parameters: {
      min: 1000,
      max: null
    },
    one_minute: {
      //window.USR_SM_CMP_SIMULATORE_PROD_TABELLE.ONE_MINUTE
      codes: {
        "9XX": 855,
        "9XZ": 855,
        //Codice tabella OCS -> cambia quando cambiano quelle sopra;
        "9XX_CODE": "5MB",
      },
      parameters: {
        min: 1000,
        max: null
      },
    },
    endpointOrigin: `https://api.mycompass.app`,
  }
};